import React from "react";
import Card from "components/Layout/Card";
import { useNavigate } from "react-router-dom";
import { icons } from "utils/constants";
import { getDataFromLocalStorage, getEventDate } from "utils/helpers";

const NewAbstractBasicDetails = ({ eventData, submission_type }) => {
  const navigate = useNavigate()
  const educationalDetails = getDataFromLocalStorage("educational_details");
  const { event_name, start_date, end_date, city_name
    , country_name } = eventData;
  const {
    phd_university_name,
    phd_department_name,
    phd_course_name,
    pg_university_name,
    pg_department_name,
    pg_course_name,
    ug_university_name,
    ug_department_name,
    ug_course_name,
  } = educationalDetails;

  const university =
    phd_university_name || pg_university_name || ug_university_name;
  const department =
    phd_department_name || pg_department_name || ug_department_name;
  const course = phd_course_name || pg_course_name || ug_course_name;

  return (
    // <div className="col-md-4">
    //   <Card className="cps-20 cpe-20 cpt-30 cpb-20">
    //     <div className="text-14-400-18 color-new-car">Conference Name:</div>
    //     <p className="text-14-400-24 color-black-olive">{event_name}</p>
    //     <div className="text-14-400-18 color-new-car">Date:</div>
    //     <p className="text-14-400-24 color-black-olive">
    //       {getEventDate(start_date, end_date)}
    //     </p>
    //     <div className="text-14-400-18 color-new-car">University:</div>
    //     <p className="text-14-400-24 color-black-olive">{university}</p>
    //     <div className="text-14-400-18 color-new-car">Course:</div>
    //     <p className="text-14-400-24 color-black-olive">{course}</p>
    //     <div className="text-14-400-18 color-new-car">Department:</div>
    //     <p className="text-14-400-24 color-black-olive">{department}</p>
    //   </Card>


    // </div>

    <Card className="cp-20 cmb-18">
      <div className="d-flex gap-1 cmb-15">
        <span
          className="d-flex"
          onClick={() => {
            navigate(-1);
          }}
        >
          <img src={icons.leftArrow} alt="back" className="h-21 me-2 pointer" />
        </span>
        <div className="text-16-500 color-black-olive"> {submission_type ? `${submission_type} Submission` : 'Paper Submission'}</div>
      </div>
      <div className="row">
        <div className="col-md-9 col-sm-9 col-12">
          <div className="text-14-400-18 color-new-car">Conference Name:</div>
          <p className="text-14-400-24 color-black-olive">{event_name}</p>
        </div>

        <div className="col-md-3 col-sm-3 col-12">
          <div className="text-14-400-18 color-new-car">Conference City:</div>
          <p className="text-14-400-24 color-black-olive">
            {city_name}, {country_name}
          </p>
        </div>
      </div>
      <div className="row">


        <div className="col-md-4 col-sm-6 col-12">
          <div className="text-14-400-18 color-new-car">University:</div>
          <p className="text-14-400-24 color-black-olive">{university}</p>
        </div>

        <div className="col-md-3 col-sm-6 col-12">
          <div className="text-14-400-18 color-new-car">Department:</div>
          <p className="text-14-400-24 color-black-olive">{department}</p>
        </div>

        <div className="col-md-2 col-sm-6 col-12">
          <div className="text-14-400-18 color-new-car">Course:</div>
          <p className="text-14-400-24 color-black-olive">{course}</p>
        </div>


        <div className="col-md-3 col-sm-6 col-12">
          <div className="text-14-400-18 color-new-car">Date:</div>
          <p className="text-14-400-24 color-black-olive">
            {getEventDate(start_date, end_date)}
          </p>
        </div>
      </div>

    </Card>
  );
};

export default NewAbstractBasicDetails;
